export const removeSlashes = (path: string) => path.replace(/\//g, '')
